import { useState } from "react";
import { CTA } from "@merchstores/shared/elements/Cta";
import { useStore } from 'react-redux';

import { buildCheckoutFields, requestCheckoutUrl, ICheckoutFields } from "./CartCheckout";

export interface ICartCheckoutCTAProps {
    display?: boolean
}

export const CartCheckoutCTA : React.FC<ICartCheckoutCTAProps> = (props: ICartCheckoutCTAProps) => {
  const reduxStore = useStore();
  const [waitForSubmit, setWaitForSubmit] = useState(false);

  const handleProceedToCheckout = async () =>
  {
    setWaitForSubmit(true);
    // use the updated current store state
    const cart = reduxStore.getState().cart;
    const merchstore = reduxStore.getState().merchstore;
    const checkoutFields: ICheckoutFields = buildCheckoutFields(cart, merchstore);

    try {
      const checkoutResponse = await requestCheckoutUrl(checkoutFields);

      if (checkoutResponse.checkoutUrl)
      {
        window.location.assign(checkoutResponse.checkoutUrl);
      }
    }
    catch (err)
    {
      console.error(err);
    }

    setWaitForSubmit(false)
  }

  if (props.display === false)
  {
    return null;
  }

  return (
    <div className="cart-checkout-cta">
      <CTA 
        type="merchstore-primary" 
        size="standard" 
        classes="text-sm w-full" 
        onClick={handleProceedToCheckout}
        disabled={waitForSubmit}>
        { waitForSubmit ? "Loading..." : "Proceed to Checkout" }
      </CTA>
    </div>
  )
}